import React, { useState, useEffect, useContext } from 'react'
import classnames from "classnames";

import {
    Card,
    CardBody,
    CardHeader,
    Spinner
} from 'reactstrap'

import Collapse from '@mui/material/Collapse'

import PlanTable from './Plantable'

import useApi from '@hooks/useApi';
import useLoader from '@hooks/useLoader';

import { AuthContext } from '@context/AuthContext'
import { useTranslation } from 'react-i18next'
import { TimetableModal } from '@student_components/TimeTableChoise';

import { useNavigate } from "react-router-dom"

export default function StudyPlan() {

    const navigate = useNavigate()

    const [activeIdx, setActiveIdx] = useState('')
    const [datas, setDatas] = useState([])
    const [isOpen, setOpen] = useState(false)
    const [modal, setModal] = useState(false)
    const [lesson_id, setLessonId] = useState('')

    const { userDetail } = useContext(AuthContext)
    const { fetchData, isLoading } = useLoader({})

    const { t } = useTranslation()

    const surgaltApi = useApi().surgalt

    async function getDatas () {
        const { success, data } = await fetchData(surgaltApi.getPlan(userDetail?.student?.id))
        if(success)
        {
           setDatas(data)
        }
    }

    useEffect(
        () =>
        {
            if (userDetail?.student?.id) {
                getDatas()
            }
        },
        [userDetail]
    )

    const toggle = (idx) => {
        if (idx == activeIdx) {
            setOpen(!isOpen)
        } else {
            setOpen(true)
        }
        setActiveIdx(idx)
    }

    const handleChoice = (lesson_id='') => {
        // setModal(!modal)
        navigate(`choose/`, { state: { lessonId: lesson_id, studentId: userDetail?.student?.id } })
        setLessonId(lesson_id)
    }

    return (
        <Card>
            <CardHeader className='d-flex justify-content-start'>
                <i className="fal fa-calendar-alt" ></i>
                <h5 className='mb-0 ms-1'>{t(`Сургалтын төлөвлөгөө`)}</h5>
            </CardHeader>
            {
                isLoading &&
                    <div className='suspense-loader'>
                        <Spinner size='bg'/>
                        <span className='ms-50'>{t('Түр хүлээнэ үү...')}</span>
                    </div>
            }
            <CardBody>
                {datas.map((item, idx) => {
                    return (
                        <div key={idx}>
                            <div className='added-cards mb-1'>
                                <div className={classnames('cardMaster rounded border p-1 d-flex justify-content-center')} role="button" id="toggler" onClick={() => toggle(idx)}>
                                    <i className="far fa-eye link-primary" style={{ marginTop: '4px'}}></i>
                                    <p className="fs-5 fw-bold mb-0 text-center ms-1 link-primary">{t(`${item.lesson_level_name}`)}</p>
                                </div>
                            </div>
                            <Collapse in={isOpen && activeIdx == idx} timeout='auto'>
                                {
                                    item.types?.map((type, idy) => {
                                        return (
                                            <div key={idy}>
                                                <p className="fs-6 fw-bold mb-1">{type.lesson_type_sub}. {t(`${type.lesson_type_name}`)}</p>
                                                <PlanTable lessons={type.lessons} handleChoice={handleChoice}/>
                                            </div>
                                        )
                                    })
                                }
                            </Collapse>
                        </div>
                    )
                })}
            </CardBody>
            {
                modal
                &&
                    <TimetableModal isOpen={modal} handleModal={handleChoice} lessonId={lesson_id} studentId={userDetail?.student?.id}/>
            }
        </Card>
    )
}
